import React, { useEffect, useState } from "react";
import {
    HeaderContainer,
    HeaderMenuList,
    HeaderOptions,
    MenuListItem,
    OptionSearch,
} from "./style.js";
import CartButton from "./CartButton/index";
import Search from "./Search/index";
import { fetchAuth, fetchLogout } from "../../Actions/userAction";
import { useDispatch, useSelector } from "react-redux";
import Burger from "./Burger/index.js";
import BurgerNav from "./BurgerNav/index";

function Header() {
    const [open, setOpen] = useState(false);
    const { User, isLogin } = useSelector((state) => state.user);
    const dispatch = useDispatch();

    const onClick = () => {
        setOpen(!open);
    };

    useEffect(() => {
        dispatch(fetchAuth());
    }, []);

    const onLogout = () => {
        dispatch(fetchLogout());
    };

    return (
        <>
            <HeaderContainer>
                <h1>SHOPPI</h1>
                <HeaderMenuList>
                    <MenuListItem to="/">Home</MenuListItem>
                    <MenuListItem to="/product">Products</MenuListItem>
                    {isLogin ? (
                        <>
                            <MenuListItem to="#" onClick={onLogout}>
                                Logout
                            </MenuListItem>
                            <MenuListItem to="#">{User.name}</MenuListItem>
                        </>
                    ) : (
                        <MenuListItem to="/Login">Login</MenuListItem>
                    )}
                </HeaderMenuList>
                <HeaderOptions>
                    <OptionSearch
                        onClick={onClick}
                        className="options-button-search"
                        src="/svg/loupe.svg"
                        alt="searchSvg"
                    />
                    <CartButton />
                </HeaderOptions>
                <Burger open={open} onClick={onClick} />
            </HeaderContainer>
            <Search open={open} />
            <BurgerNav open={open} />
        </>
    );
}

export default Header;
